<div [class]="classNames" role="status"></div>
